//------------------------------------------------------ externos
import Swal from "sweetalert2";
//------------------------------------------------------ funciones
import { stockTypeOptions, unidadesOptions, puestosOptions, tipoEmpleadoOptions, porteriaOptions, llavesOptions, satelitalOptions, reparacionesTractoresOptions } from "../components/formularios/data/OptionsContent";
import { realtime } from "../services/store";
//import { getStock } from "../services/cols/stock.service";
import { listarColeccion } from "../services/collections.service";
import { getEmpresasProveedoras } from "../services/cols/empresas.service";
import { getSectores } from "../services/cols/sectores.service";
import { TIPOS as TIPOS_ACOPLADO } from "../shared/tipoAcoplado";
import { opcionesPropias } from "../shared/empresa";
import { enAR, diaAr, diaHoraAr, fechaParaGuardar } from "../shared/fechaAr";

// Formatea strings "AAAA-MM-DD" o "AAAA-MM-DDTHH:MM" (el formato que
// usan los inputs date/datetime-local de Viajes y cargas de
// combustible) a DD/MM/AAAA, agregando HH:MM cuando la fecha lo trae.
// Si el valor no matchea ese patrón, se devuelve tal cual en vez de
// romper la pantalla.
export const formatearFecha = (valor) => {
  if (!valor) return "—";
  const match = String(valor).match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/);
  if (!match) return String(valor);
  const [, anio, mes, dia, hora, minuto] = match;
  return hora && minuto ? `${dia}/${mes}/${anio} ${hora}:${minuto}` : `${dia}/${mes}/${anio}`;
};

export const convertirFecha = (fecha) => {
  if (!fecha) return new Date(0);

  // Firestore timestamp
  if (fecha.seconds) {
    return new Date(fecha.seconds * 1000);
  }

  // Date nativo
  if (fecha instanceof Date) {
    return fecha;
  }

  // String ISO
  return new Date(fecha);
};

export const limpiarFecha = (fecha) => {
  // para comparar fechas 

  if (!fecha) return 0;

  if (typeof fecha.toDate === "function") {
    return fecha.toDate().getTime();
  }
  if (fecha.seconds) {
    return fecha.seconds * 1000;
  }

  if (fecha instanceof Date) {
    return fecha.getTime();
  }

  if (typeof fecha === "string") {
    return new Date(fecha).getTime();
  }

  return 0;
};

export const formatearCampoFirestore = (valor) => {
  // de firestore al front
  if (valor === null || valor === undefined) return "-";

  if (typeof valor === "boolean") return valor ? "Activo" : "Inactivo";

  // fechas
  const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/; // formato 2025-08-22T08:00:00Z
  const isoRegex2 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{3}Z$/; // formato 2025-08-22T08:00:000Z (error)

  // Todo lo que es un instante se lee en hora argentina (fechaAr), no en la
  // del navegador: el mismo timestamp decía cosas distintas según la máquina.
  if (typeof valor === "string" && isoRegex.test(valor)) {
    return diaAr(valor);
  }
  if (typeof valor === "string" && isoRegex2.test(valor)) {
    // corregir y eliminar el 0 de más en 000Z (debe ser 00Z)
    const corregido = valor.replace(
      /T(\d{2}:\d{2}):(\d{3})Z$/,
      "T$1:00.$2Z"
    );

    return diaAr(corregido);
  }
  if (typeof valor.toDate === "function") {
    return diaHoraAr(valor.toDate());
  }
  if (valor?.seconds) {
    return diaHoraAr(new Date(valor.seconds * 1000));
  }

  // array y objetos
  if (Array.isArray(valor)) {
    return valor
      .map(v => (typeof v === "object" ? "[obj]" : v))
      .join(", ");
  }
  if (typeof valor === "object") {
    if (valor.nombre) return valor.nombre;
    if (valor.id) return valor.id;
    // fechas
    if (typeof valor._seconds === "number") {
      return diaAr(new Date(valor._seconds * 1000));
    }

    if (typeof valor.seconds === "number") {
      return diaAr(new Date(valor.seconds * 1000));
    }

    if (typeof valor.toDate === "function") {
      return diaAr(valor.toDate());
    }



    //return JSON.stringify(valor);


    return "[Objeto]";
  }

  return valor.toString();
};

export const formatearCampoParaCarga = (valor, tipo) => {
  if (valor === "" || valor === null || valor === undefined) return null;

  switch (tipo) {
    case "number":
      return Number(valor);

    case "boolean":
      if (typeof valor === "boolean") return valor;
      return valor === "true" || valor === "1";

    case "date":
      // El día escrito viaja como texto y el datetime-local con el -03:00
      // clavado: `new Date("2026-08-31")` era medianoche UTC y el día se
      // guardaba corrido (ver fechaAr.js).
      return fechaParaGuardar(valor);

    case "array":
      return Array.isArray(valor) ? valor : [valor];

    /* UNA CLAVE DE VOCABULARIO NO SE PASA A MAYÚSCULAS.
     *
     * `text` sí, y está bien: el padrón entero se guarda en mayúscula. Pero un
     * valor que una lista cerrada compara EXACTO —un `check` en la base, un
     * `Set` en el JavaScript— deja de matchear apenas se lo toca: `chocado`
     * pasa a `CHOCADO`, la base rechaza la fila entera y el cartel dice «no
     * hemos podido procesar la solicitud» sin nombrar el campo. Es el mismo
     * modo de falla que la columna `ultimaModificacion` que le faltaba a
     * `furgones`.
     *
     * Se trimea igual: un espacio de más tampoco matchea. */
    case "clave":
      return String(valor).trim();

    case "text":
    default:
      return String(valor).toUpperCase().trim();
  }
};

export const capitalizarTexto = (texto) => {
  return texto.charAt(0).toUpperCase() + texto.slice(1).toLowerCase();
}

export const renderizarValor = (valor, col, style = "normal") => {
  if (valor === null || valor === undefined) return "-";

  // 🔥 Firestore timestamp — leído en hora argentina, no en la del navegador
  if (valor?.seconds || valor?._seconds) {
    return diaHoraAr(new Date((valor.seconds || valor._seconds) * 1000));
  }

  // Date nativo
  if (valor instanceof Date) {
    return diaHoraAr(valor);
  }

  // Boolean
  if (typeof valor === "boolean") {
    return valor ? "Activo" : "Inactivo";
  }

  // Array
  if (Array.isArray(valor)) {
    return valor.join(", ");
  }

  // Objeto dinámico
  if (typeof valor === "object" && col) {
    return valor[col] ?? "[Objeto]";
  }

  // Estilos
  let valorFinal;

  switch (style) {
    case "upper":
      valorFinal = typeof valor === "string" ? valor.toUpperCase() : valor;
      break;
    case "lower":
      valorFinal = typeof valor === "string" ? valor.toLowerCase() : valor;
      break;
    default:
      valorFinal = valor;
      break;
  }

  return valorFinal;
};

export const minimizarVehiculo = (tipoVehiculo) => {
  if (!tipoVehiculo) {
    return "";
  }
  let tipo;
  switch (tipoVehiculo.toUpperCase()) {
    case "TRACTORES": tipo = "TRACTOR"; break;
    case "FURGONES": tipo = "FURGON"; break;
    default: tipo = "VEHICULO"; break;
  }
  return tipo;
};

export const cargarOpciones = async (campos) => {
  try {

    const collectionsToLoad = [
      ...new Set(
        campos
          .filter(c => c.inputType === "inputOptions")
          .map(c => c.optionsConfig.collection)
      )
    ];

    const resultado = {};

    await Promise.all(
      collectionsToLoad.map(async (collection) => {
        const data = await listarColeccion(collection);
        resultado[collection] = Array.isArray(data) ? data : [];
      })
    );

    return resultado;

  } catch (error) {
    console.error("[Error] cargando opciones:", error);
    return {};
  }
};

export const cargarSelects = async () => {
  // `getEmpresasPropias()` ya no está: las cuatro propias salen del glosario
  // (ver `empresasPropias` abajo), así que traerlas de la base era un viaje
  // por una lista que nadie miraba.
  const [empresasProveedoras, stockType, unidades, sectores, puestos, tipoEmpleados, tiposPorteria, tiposLlaves, tiposSatelital, tiposReparacionesTractores] = await Promise.all([
    getEmpresasProveedoras(),
    stockTypeOptions(),
    unidadesOptions(),
    getSectores(),
    puestosOptions(),
    tipoEmpleadoOptions(),
    porteriaOptions(),
    llavesOptions(),
    satelitalOptions(),
    reparacionesTractoresOptions(),
  ]);

  const personas = realtime.personas;
  const mecanicos = realtime.mecanicos;
  const tractores = realtime.tractores;
  const furgones = realtime.furgones;
  const vehiculos = realtime.vehiculos;
  const choferes = realtime.choferes;
  const serenos = realtime.serenos;
  const stock = realtime.stock;
  const proveedores = realtime.proveedores;
  const depositos = realtime.depositos;
  const ubicaciones = realtime.ubicaciones;

  return {
    /* Las tres carrocerías de acoplado. Salen del CATÁLOGO y no de la base:
     * son un vocabulario cerrado que el `check` de la columna ya fija, así que
     * una consulta acá devolvería exactamente lo mismo con una ida de más — y
     * el primer día devolvería una lista VACÍA, porque no hay ninguna fila
     * cargada. Un desplegable sin opciones se lee como que la pantalla se
     * rompió, y es justo el día que hay que empezar a llenar la columna. */
    tiposAcoplado: TIPOS_ACOPLADO.map(t => ({ value: t.clave, label: t.etiqueta })),
    /* LAS CUATRO PROPIAS SALEN DEL GLOSARIO, no de `empresas.tipo='propia'`.
     *
     * Esa consulta devolvía DOS —EX y TCC—: en la tabla `empresas`, TC figura
     * como «FILTER GROUP S.A» y TA como «TAYLOR», las dos marcadas
     * `proveedor`. Con eso, a la mitad de la gente y de la flota no se le
     * podía elegir empresa en ningún formulario.
     *
     * No se arregla tocando esas dos filas: llevan código de proveedor (56 y
     * 57) y el módulo de repuestos las usa por ahí. `shared/empresa.js` ya es
     * el glosario que manda en el resto del hub, y devuelve el CUIT, que es
     * lo que guardan los padrones. */
    empresasPropias: opcionesPropias(),
    empresasProveedoras: empresasProveedoras.map(e => ({
      value: e.id,
      label: `${e.nombre} (${e.cuit})`,
      raw: e
    })),
    proveedores: proveedores.map(e => ({
      value: e.id,
      label: `${e.id} - ${e.marca} | ${e.cuit} (${e.nombre})`,
      raw: e
    })),
    personas: personas.map(ps => ({
      value: ps.id,
      label: `${ps.nombreCompleto}`,
      raw: ps
    })),
    mecanicos: mecanicos.map(ch => ({
      value: ch.id,
      label: `${ch.nombreCompleto}`,
      raw: ch
    })),
    choferes: choferes.map(ch => ({
      value: ch.id,
      label: `${ch.nombreCompleto}`,
      raw: ch
    })),
    serenos: serenos.map(sr => ({
      value: sr.id,
      label: `${sr.nombreCompleto}`,
      raw: sr
    })),
    tractores: tractores.map(tr => ({
      value: tr.id,
      label: tr.label,
      raw: tr
    })),
    furgones: furgones.map(fg => ({
      value: fg.id,
      label: fg.label,
      raw: fg
    })),
    vehiculos: vehiculos.map(vh => ({
      value: vh.id,
      label: vh.label,
      raw: vh
    })),
    ubicaciones: ubicaciones.map(ub => ({
      value: ub.id,
      label: `${ub.id} - ${ub.nombre}`,
      raw: ub
    })),
    stock: stock.map(ub => ({
      value: ub.id,
      label: `${ub.descripcion} ${ub.nombreProveedor}`,
      raw: ub
    })),
    stockType: Object.entries(stockType).map(([key, st]) => ({
      value: st.tipo,
      label: `${st.tipo} (${st.descripcion})`,
      raw: st
    })),

    unidades: Object.entries(unidades).map(([key, um]) => ({
      value: um.descripcion,
      label: `${key} - ${um.descripcion}`,
      raw: um,
    })),
    depositos: depositos.map(dp => ({
      value: dp.id,
      label: `${dp.nombre}`,
      raw: dp
    })),
    sectores: sectores.map(s => ({
      value: s.nombre,
      label: `${s.id} - ${s.nombre}`,
      raw: s
    })),
    puestos: Object.values(puestos).map((p) => ({
      value: p.key,
      label: p.descripcion,
      raw: p
    })),

    tipoEmpleados: Object.values(tipoEmpleados).map((te) => ({
      value: te.key,
      label: te.descripcion,
      raw: te
    })),
    tiposPorteria: Object.entries(tiposPorteria).map(([key, po]) => ({
      value: po.value,
      label: `${po.value} (${po.label})`,
      raw: po
    })),
    tiposSatelital: Object.entries(tiposSatelital).map(([key, st]) => ({
      value: st.value,
      label: st.label,
      raw: st
    })),
    llaves: Object.entries(tiposLlaves).map(([key, lv]) => ({
      value: lv.value,
      label: lv.label,
      raw: lv
    })),
    tiposTractores: Object.entries(tiposReparacionesTractores).map(([key, tr]) => ({
      value: tr.value,
      label: tr.label,
      raw: tr
    })),

  };
};

export const formatearFechaInput = (valor) => {
  if (!valor) return "";

  /* El día ya escrito se corta como TEXTO. Pasarlo por Date lo hacía
   * medianoche UTC y el getDate() local mostraba el día ANTERIOR en el
   * input — y al guardar, la fecha corrida se persistía de verdad. */
  if (typeof valor === "string") {
    const s = valor.trim();
    if (/^\d{4}-\d{2}-\d{2}($|[T ]\d{2}:\d{2}(:\d{2}(\.\d+)?)?$)/.test(s)) {
      return s.slice(0, 10);
    }
    const d = enAR(s);                 // instante con huso → día argentino
    return d ? `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, "0")}-${String(d.getUTCDate()).padStart(2, "0")}` : "";
  }

  let fecha;
  if (valor._seconds !== undefined) {
    fecha = new Date(valor._seconds * 1000);
  } else if (valor instanceof Date) {
    fecha = valor;
  } else {
    return "";
  }

  const d = enAR(fecha);
  if (!d) return "";
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, "0")}-${String(d.getUTCDate()).padStart(2, "0")}`;
};

export const buscarCampo = (coleccion, index, campo) => {
  if (!Array.isArray(coleccion) || index === undefined || !campo) return "";

  const valor = coleccion.find((item) => String(item.id) === String(index));

  return valor?.[campo] ?? "";
}



export const idCorrelativo = (listado) => {
  if (!Array.isArray(listado)) return "01";

  const ids = listado.map((item) => Number(item?.id)).filter((id) => !isNaN(id));

  const maxId = ids.length > 0 ? Math.max(...ids) : 0;
  const codigo = maxId + 1;
  return (codigo) < 10 ? `0${codigo}` : String(codigo);
}

export const verificarCamposObligatorios = (campos, formData) => {
  // verificación para forms
  const cantObligatorios = campos.filter((cp) => cp.important);
  const cantCompletados = campos.filter(
    (cp) =>
      cp.important &&
      formData[cp.key] !== null &&
      formData[cp.key] !== undefined &&
      formData[cp.key].toString().trim() !== "",
  );

  if (cantObligatorios.length !== cantCompletados.length) {
    Swal.fire({
      title: "Faltan datos",
      text: "Complete los campos obligatorios.",
      icon: "question",
      confirmButtonText: "Entendido",
      confirmButtonColor: "#4161bd",
    });

    return false;
  }

  return true;
}

export const estandarizarCampo = (campo) => {
  let valor;

  switch (campo) {
    case "number":
      valor = valor === "" ? null : Number(valor);
      break;

    case "text":
      valor = valor === "" ? null : String(valor).toUpperCase();
      break;

    case "date":
      valor = valor ? formatearCampoFirestore(valor) : null;
      break;

    case "boolean":
      valor = Boolean(valor);
      break;

    default:
      valor = valor === "" ? null : valor;
      break;
  }

  return valor;
}

export const generarCodigoStock = async (tipo, proveedor) => {
  if (!tipo || !proveedor) return null;

  // 1 -------------------------------------- DEFINIR TIPO | EJ: "AC"
  const stockTypes = stockTypeOptions();
  const codTipo = Object.entries(stockTypes).find(
    ([_, value]) =>
      value.tipo.toLowerCase() === tipo.toLowerCase()
  )?.[0];
  // 2 -------------------------------------- DEFINIR CODIGO PROVEEDOR | EJ: "07"
  const codProv = String(proveedor).padStart(2, "0");
  const prefijo = `${codTipo}${codProv}` // PREFIJO EJ: "AC07"

  // 3 -------------------------------------- DEFINIR ORDEN | EJ: "0012"
  //const stock = await getStock();
  const stock = realtime.stock;
  const codigos = stock.map(st => st.id).filter(id => id.slice(0, 4) === prefijo);

  let ultimo = 0;

  if (codigos.length > 0) {
    ultimo = Math.max(...codigos.map(codigo => Number(codigo.slice(-4))));
  };

  const correlativo = String(ultimo + 1).padStart(4, "0");

  // 4 -------------------------------------- CODIGO FINAL | EJ: "AC070012"

  const codigo = `${prefijo}${correlativo}`;

  return codigo;
};